
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconBottomOfRow = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M22.55 5.52h-18a.5.5 0 00-.55.447V13.1a.5.5 0 00.493.5H1.561a.5.5 0 00-.5.5v4.04a.5.5 0 00.5.5h18a.5.5 0 00.5-.5V14.1a.5.5 0 00-.493-.5H22.5a.5.5 0 00.5-.5V6a.5.5 0 00-.45-.48zM22 12.6H5V6.52h17z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M22.55 5.52h-18a.5.5 0 00-.55.447V13.1a.5.5 0 00.493.5H1.561a.5.5 0 00-.5.5v4.04a.5.5 0 00.5.5h18a.5.5 0 00.5-.5V14.1a.5.5 0 00-.493-.5H22.5a.5.5 0 00.5-.5V6a.5.5 0 00-.45-.48zM22 12.6H5V6.52h17z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M22.55 5.52h-18a.5.5 0 00-.55.447V13.1a.5.5 0 00.493.5H1.561a.5.5 0 00-.5.5v4.04a.5.5 0 00.5.5h18a.5.5 0 00.5-.5V14.1a.5.5 0 00-.493-.5H22.5a.5.5 0 00.5-.5V6a.5.5 0 00-.45-.48zM22 12.6H5V6.52h17z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconBottomOfRow.displayName = 'IconBottomOfRow';
export default IconBottomOfRow;